// EmailValidatorUtil.js
export default class EmailValidatorUtil {
    /**
     * Valida um endereço de e-mail de acordo com regras específicas
     * 
     * @param {string} email - O endereço de e-mail a ser validado
     * @returns {Object} - Objeto com resultado da validação (valido: boolean, mensagem: string)
     */
    static validar(email) {
      
      // Verifica se o email está vazio
      if (!email || email.trim() === '') {
        return { valido: false, mensagem: 'O campo de e-mail não pode estar vazio.' };
      }
  
      // Verifica se há espaços em branco
      if (/\s/.test(email)) {
        return { valido: false, mensagem: 'O e-mail não pode conter espaços em branco.' };
      }
  
      // Verifica se possui exatamente um @
      if (!email.includes('@') || email.indexOf('@') !== email.lastIndexOf('@')) {
        return { valido: false, mensagem: 'O e-mail deve conter exatamente um símbolo @.' };
      }
  
      // Divide o email em nome de usuário e domínio
      const [usuario, dominio] = email.split('@');
  
      // Verifica se o usuário ou domínio estão vazios
      if (!usuario || !dominio) {
        return { valido: false, mensagem: 'O e-mail deve ter um nome de usuário e um domínio.' };
      }
  
      // Verifica se o usuário inicia com ponto ou underline
      if (usuario.startsWith('.') || usuario.startsWith('_')) {
        return { valido: false, mensagem: 'O e-mail não pode iniciar com ponto ou underline.' };
      }
  
      // Verifica se há dois pontos consecutivos
      if (email.includes('..')) {
        return { valido: false, mensagem: 'O e-mail não pode conter dois pontos consecutivos.' };
      }
  
      // Verifica se o domínio contém pelo menos um ponto
      if (!dominio.includes('.')) {
        return { valido: false, mensagem: 'O domínio deve conter pelo menos um ponto (ex: .com, .com.br).' };
      }
  
      // Verifica se a extensão após o último ponto tem pelo menos 2 caracteres
      const extensao = dominio.split('.').pop();
      if (extensao.length < 2) {
        return { valido: false, mensagem: 'A extensão do domínio deve ter pelo menos 2 caracteres.' };
      }
  
      // Verifica se o email contém apenas caracteres permitidos
      const regexPermitidos = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9._-]+\.[a-zA-Z]{2,}$/;
      if (!regexPermitidos.test(email)) {
        return { 
          valido: false, 
          mensagem: 'O e-mail contém caracteres não permitidos. Use apenas letras, números, pontos, underlines e hífens.' 
        };
      }
  
      // Se passou por todas as validações, o email é válido
      return { valido: true, mensagem: '' };
    }
  
    /**
     * Compara dois emails para verificar se são iguais
     * 
     * @param {string} emailPrincipal - O e-mail principal
     * @param {string} emailSecundario - O e-mail secundário a ser comparado
     * @returns {Object} - Objeto com resultado da comparação (iguais: boolean, mensagem: string)
     */
    static compararEmails(emailPrincipal, emailSecundario) {
      if (emailPrincipal === emailSecundario) {
        return { iguais: true, mensagem: 'Os e-mails não podem ser iguais.' };
      }
      return { iguais: false, mensagem: '' };
    }
  }